export class JobPermissionsResponse {
  public canChangeContactDetails = false
  public canTakeManualPayments = false
}
